namespace Matrix.Workflow {

    @Serenity.Decorators.element("<div/>")
    @Serenity.Decorators.editor()
    export class DiffView extends SiteEntityGrid<DiffItem, any> {

        getColumnsKey() { return "Workflow.DiffView"; }
        getIdProperty() { return "Field"; }

        private isUpdateMode: boolean;

        constructor(container) {
            super(container);
        }

        getPersistanceStorage() {
            return null;
        }

        setDiff(oldValues: any, newValues: any, fieldTitles: any) {
            this.isUpdateMode = Object.keys(oldValues).length > 0 &&
                Object.keys(newValues).length > 0;

            var items: DiffItem[] = [];
            var itemByField: Q.Dictionary<DiffItem> = {};
            for (var name of Object.keys(oldValues)) {
                var item: DiffItem = {
                    Field: name,
                    Title: fieldTitles[name] || name,
                    OldValue: oldValues[name],
                    NewValue: null
                };
                items.push(item);
                itemByField[item.Field] = item;
            }

            for (var name of Object.keys(newValues)) {
                var item = itemByField[name];
                if (!item) {
                    item = {
                        Field: name,
                        Title: fieldTitles[name] || name,
                        OldValue: oldValues[name],
                        NewValue: null
                    }

                    items.push(item);
                    itemByField[item.Field] = item;
                }

                item.NewValue = newValues[name];
            }

            items.sort((x, y) => Q.turkishLocaleCompare(x.Title, y.Title));
            this.view.setItems(items, true);
            
        }

        getInitialTitle() {
            return null;
        }

        getGridCanLoad() {
            return false;
        }

        protected getButtons() {
            return null;
        }

        protected createQuickSearchInput() {
        }

        protected usePager() {
            return false;
        }

        protected getColumns() {
            var columns = super.getColumns();
            var o = Q.tryFirst(columns, x => x.field == 'OldValue');
            o && (o.format = ctx => {
                if ($.isArray(ctx.value) && ctx.value.length && (ctx.item.NewValue == null || $.isArray(ctx.item.NewValue)) &&
                    (typeof ctx.value[0] == "string" || typeof ctx.value[0] == "number")) {
                    var o = ctx.value;
                    var n = Q.coalesce(ctx.item.NewValue, []) as any[];
                    o.sort();
                    var t = "";
                    for (var val of o) {
                        t.length && (t += '<span class="text-black">, </span>');
                        if (n.indexOf(val) < 0)
                            t += `<span class="text-red">${Q.htmlEncode(val)}</span>`;
                        else
                            t += `<span class="text-black">${Q.htmlEncode(val)}</span>`;
                    }
                    return t;
                }
                return Q.htmlEncode(ctx.value);
            });
            var n = Q.tryFirst(columns, x => x.field == 'NewValue');
            n && (n.format = ctx => {
                if ($.isArray(ctx.value) && ctx.value.length && (ctx.item.OldValue == null || $.isArray(ctx.item.OldValue)) &&
                    (typeof ctx.value[0] == "string" || typeof ctx.value[0] == "number")) {
                    var n = ctx.value;
                    var o = Q.coalesce(ctx.item.OldValue, []) as any[];
                    n.sort();
                    var t = "";
                    for (var val of n) {
                        t.length && (t += '<span class="text-black">, </span>');
                        if (o.indexOf(val) < 0)
                            t += `<span class="text-blue">${Q.htmlEncode(val)}</span>`;
                        else
                            t += `<span class="text-black">${Q.htmlEncode(val)}</span>`;
                    }
                    return t;
                }
                return Q.htmlEncode(ctx.value);
            });

            return columns;
        }

        getItemCssClass(item, index) {
            var klass = super.getItemCssClass(item, index) || "";
            if (this.isUpdateMode && item.OldValue != item.NewValue)
                klass += " diff-modified";
            return klass;
        }
    }

    export interface DiffItem {
        Field: string;
        Title: string;
        OldValue: string;
        NewValue: string;
    }
}